export interface NavigationSection {
  name: string;
  pages?: NavigationItem[];
}

export interface NavigationItem {
  name: string;
  icon: string;
  route?: string;
  featureName: string;
  applicationName: string;
  isAdmin?: boolean;
  isOwner?: boolean;
  role: string;
  hidden: boolean;
  visible: boolean;
  children?: NavigationItemChild[];

  toggled: boolean; 
}

export interface NavigationItemChild {
  name: string;
  external: boolean;
  route: string;
  isAdmin?: boolean;
  featureName: string;
  role: string;
}

export interface LicensePlugin {
  name: string;
  typeName: string;
  description: string;
  input: boolean;
  pipeline: boolean;
  output: boolean;
  price ?: number;
  requiresLicense: boolean;
  categorys: string[];
}

export interface CustomerLicense {
  licenseID: string;
  licenseNumber: string;
  expiredDate: string;
  licenseType: string;
  licenseStatus: string;
  userID: string;
  licenseKey: string;
  serverToken: string;
  uriCount: number;
  validTo: string;
  issuedDate: string;
  offlineable: boolean;
  perpetualLicense: string;
  pluginLicenses: string;
  customer_ID: string;
  licenseName: string;
  licenseString: string;
}

export interface URIInfo {
  uriCount: string;
  price: number;
}

export interface LicenseOrder {
  orderID: string;
  customerName: string;
  uriCount: string;
  licensesPlugins: string;
  totalPrice: number;
  orderStatus: string;
  creationDate: string;
  paidDate: string;
  }

export enum LicenseStatus {
    PENNDING,
    PROCESSING,
    APPROVED,
    ACTIVATED,
    EXPIRED
  }

